(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/store/wagers-slice.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/store/wagers-slice.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const logger = svs.arena.logger;
const {
  getTeamWagersAsync
} = svs.arena.service.wagersService;
const fetchTeamWagers = RTK.createAsyncThunk('arena/fetchteamwagers', async (teamId, _ref) => {
  let {
    rejectWithValue
  } = _ref;
  try {
    const response = await getTeamWagersAsync(teamId);
    if (!response || response !== null && response !== void 0 && response.error) {
      return rejectWithValue({
        error: response.error.code
      });
    }
    return {
      status: 'success',
      error: null,
      teamId,
      data: response === null || response === void 0 ? void 0 : response.data
    };
  } catch (error) {
    return rejectWithValue({
      error
    });
  }
});

const getInitialState = () => ({
  0: {
    wagers: [],
    moreItem: false
  }
});
const wagersSlice = RTK.createSlice({
  name: 'wagers',
  initialState: getInitialState(),
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchTeamWagers.fulfilled, (state, action) => {
      logger.debug('fetchTeamWagers.fulfilled, action: ', action);
      const lastFetch = new Date().getTime();
      state[action.payload.teamId] = {
        wagers: action.payload.data.wagers,
        moreItems: action.payload.data.moreItems,
        lastFetch
      };
    });
  }
});
svs.arena.store.wagers = svs.arena.store.wagers || {};
svs.arena.store.wagers.actions = _objectSpread({
  fetchTeamWagers
}, wagersSlice.actions);
svs.arena.store.wagers.reducer = wagersSlice.reducer;
svs.arena.store.wagers.initialState = getInitialState();

 })(window);